import { Directive, HostListener, Input, OnInit, output } from '@angular/core'
import { _Retry, loadScript } from '@naturalcycles/js-lib'
import { AuthMode } from '@naturalcycles/shared'
import { Decorate } from '@src/app/core/decorators/decorators.js'
import { ErrorHandlerType } from '@src/app/shared/typings/enum/error-handler.js'
import { LoaderType } from '@src/app/shared/typings/ui.js'
import { env } from '@src/environments/environment.js'
import { AppleAuthUser } from '../typings/interfaces/user-auth.js'

interface InitAppleIDInput {
  clientId: string
  scope: string
  redirectURI: string
  usePopup: boolean
  state?: string
}

interface AppleIDLibrary {
  auth: {
    init: (input: InitAppleIDInput) => void
    signIn: () => void
  }
}

declare global {
  interface Window {
    AppleID: AppleIDLibrary
  }
}

@Directive({
  selector: '[appleAuth]',
  standalone: false,
})
export class AppleAuthDirective implements OnInit {
  @Input()
  mode = AuthMode.login

  signin = output<AppleAuthUser>()

  private AppleID: AppleIDLibrary | undefined

  async ngOnInit(): Promise<void> {
    await this.loadAppleSignInScript()
    this.AppleID = window.AppleID
    this.AppleID.auth.init({
      clientId: env.appleWebClientId,
      scope: 'email',
      redirectURI: env.apiUrl + '/sessions/appleAuthCallback',
      usePopup: false,
      state: this.mode,
    })
  }

  @HostListener('click')
  public async onClick(): Promise<void> {
    await this.openAppleSignIn()
  }

  @_Retry()
  private async loadAppleSignInScript(): Promise<void> {
    await loadScript(
      `https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js`,
    )
  }

  @Decorate({
    loaderType: LoaderType.BLOCKING,
    errorHandlerType: ErrorHandlerType.DIALOG,
  })
  public async openAppleSignIn(): Promise<void> {
    return this.AppleID?.auth.signIn()
  }
}
